import React, { Component } from 'react';
import GeckoField from './field';

class GeckoFields extends Component {

    // Check if field should be hidden
    isHidden(field) {
        return field.hideWhen ? field.hideWhen() : false;
    }

    renderField(field, i) {
        if (field.render && !this.isHidden(field)) {
            return (
                <div key={i} className={field.className || ''}>
                    {field.render()}
                </div>
            );
        }

        if (!this.isHidden(field)) {
            return (
                <div key={i} className={field.className || ''}>
                    <GeckoField field={field} values={this.props.values} handler={this.props.handler.bind(this)} />
                </div>
            );
        }
        return null;
    }

    submitForm(event) {
        // Stop the form from reloading the page
        event.preventDefault();
        // Fire custom submit handler
        return this.props.submitHandler();
    }

    render() {
        return (
            <form className="flex flex-col gap-4" onSubmit={this.submitForm.bind(this)}>
                {this.props.fields.map((field, i) => this.renderField(field, i))}
                <input className="hidden" type="submit" value="#" />
            </form>
        );
    }
}

GeckoFields.defaultProps = {
    fields: [],
    values: {},
    handler: () => {},
    submitHandler: () => {}
};

export default GeckoFields;